import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Icon } from "@iconify/react";
import Styles from "./styles.module.scss";
import SearchBar from "../../components/searchbar";
import Button from "../../components/button";
import PopupMenu from "../../components/popupmenu";
import Breadcrumbs from "../../components/breadCrumbs";
import { BreadcrumbLinkMouseEvent, DataModel } from "@progress/kendo-react-layout";
import PositionFilter from "../../modal/positionFilter";
import ResourceFilter from "../../modal/resourceFilter";
import CompanyFilter from "../../modal/companyFilter"
import Toggle from "../../components/toggleButton";
import { priorityClass , checkPriority , checkTimesheetStatus } from '../../utils/EllowUtils';
import classnames from "classnames";
import DashboardFilter from "../../modal/dashboardFilter/index";
import TimsheetDurationFilter from "../../modal/timesheetDurationFilter"
import CompanyTimesheetFilter from "../../modal/companyTimesheetFilter";
import CandidateTimesheetFilter from "../../modal/candidateTimesheetFilter"
import NotificationTab from "../../components/noticationTab/index"
import ReportsDurationFilter from "../../modal/reportsDurationFilter";
import CRresourceFilter from "../../modal/CRresourceFilter";
import InContractFilter from "../../modal/inContractFilter"
import CRPositionFilter from "../../modal/CRpositionFilter"

interface Props {
  title: any;
  navigateTo?: any;
  searchChange: any;
  popupMenu?: boolean;
  jobId?: string;
  candidateLoginId?: string;
  updatePosition?: any;
  onClick?: any;
  filterNumber?: any;
  filterValues?: any;
  closeTag?: any;
  type?: string;
  companyList?: any;
  allocatedTo?: any;
  applyFilter?: any;
  applyResourceFilter?:any;
  applyCompanyFilter?:any;
  positionName?: any;
  jobStatus?: number;
  companyName?: any;
  priority?: any;
  seachBarKey?: any;
  dashboard?: boolean;
  applyDashboardFilter?: any;
  applyCompanysheetFilter?: any;
  applyCandidatesheetFilter?: any;
  candidateFilterValue ?: any;
  name?: any;
  role?: any;
  timesheetStatus?: any;
  timeSheetReportsFilter?: any;
  getProviderResources?: any;
  getRecruiterResources?: any;
  behalf_of?: any;
  positionData?: any;
  crowdsourcingChange?: any;
  applyCrPositionFilter?: any;
  applyCrResourceFilter?: any;
  allocatedToId?: any
  skillsList?: any;
  jobRolesList?: any;
}

const DashboardHeader: React.FC<Props> = ({
  title,
  navigateTo,
  searchChange,
  popupMenu,
  jobId,
  candidateLoginId,
  filterNumber,
  updatePosition,
  filterValues,
  closeTag,
  companyList,
  allocatedTo,
  type,
  applyFilter,
  applyCompanyFilter,
  positionName,
  jobStatus,
  applyResourceFilter,
  companyName,
  priority,
  seachBarKey,
  dashboard,
  name,
  role,
  applyDashboardFilter,
  applyCompanysheetFilter,
  applyCandidatesheetFilter,
  candidateFilterValue,
  timesheetStatus,
  timeSheetReportsFilter,
  getProviderResources,
  getRecruiterResources,
  behalf_of,
  positionData,
  crowdsourcingChange,
  applyCrPositionFilter,
  applyCrResourceFilter,
  allocatedToId,
  skillsList,
  jobRolesList,
  ...rest
}) => { 

  const navigate = useNavigate();
  const [filter, setFilter] = useState<boolean>(false)
  const [showNotificationTab, setshowNotificationTab] = useState<boolean>(false)
  const [resourceFilter, setResourceFilter] = useState<boolean>(false)
  const [inContractFilter, setIncontractFilter] = useState<boolean>(false)
  const [companyFilter, setCompanyFilter] = useState<boolean>(false)
  const [defaultValues, setDefaultValues] = useState<any>()
  const [companysheetFilter, setCompanysheetFilter] = useState<boolean>(false)
  const [candidatesheetFilter, setCandidatesheetFilter] = useState<boolean>(false)
  const [crResourceFilter, setCrResourceFilter] = useState < boolean>(false)
  const [crPositionFilter, setCrPositionFilter] = useState < boolean>(false)
  const openMobileMenu = () => { document.body.classList.add("mobileMenu") }

  const loginId = localStorage.getItem('loginId')
  
  const [isActive, setActive] = useState<boolean>(true);

  const ToggleClass = () => {
    setActive(!isActive); 
   }
 
  const headerNavigation = () => {

    if (navigateTo === '/CRcreateresources') {
      localStorage.setItem("ResourcesCandidateLoginId", '')
      localStorage.setItem('candidateLoginId', '')
      navigate(navigateTo, {
        state: {
          candidateLoginId: candidateLoginId,
        },
      })
    }
    if (navigateTo === "../createResources") {
    //when clicks on add new no id shold be there
    localStorage.setItem("ResourcesCandidateLoginId", '')
    localStorage.setItem('candidateLoginId', '')
    localStorage.setItem('ResourcesTab', '0');
      navigate(navigateTo, {
        state: {
          candidateLoginId: candidateLoginId,
        },
      });
    }else if (navigateTo === "../createCompany") {
      navigate(navigateTo, {
        state: {
          candidateLoginId: candidateLoginId,
        },
      });
    }
    else {
      navigate(navigateTo);
    }
  }

  let item: DataModel[] =
    title !== false && 
    title.map((item: any, key: number) => {
      return {
        id: key + 1,
        text: item,
      };
    });

  const onselect = (event: BreadcrumbLinkMouseEvent) => {
    
    if (event.id === 'Positions') {      
      navigate('../positions')
    }
    if (event.id === 'Resources') {      
      navigate('../resources')
    } 
    if (event.id === 'Companies') {      
      navigate('../company')
    }  
    if (event.id === 'CRPositions') {      
      navigate('../crpositions')
    } 
    if (event.id === 'CRResources') {      
      navigate('../CRresources')
    } 
  }

  const clickHandler = (data: any, name:string) => {    
    if (name === 'positions') {
      let value: any = {
        filters: {
          positionName: data.positionName,
          allocatedTo: data.allocatedTo,
          company: data.company,
          range: data.contractDuration,
          jobRole: data.jobRole,
          positionStatus: data.positionStatus,
          typeOfJob: data.typeOfJob,
          priority: data.priority ,
          dateWithin: data.dateWithin,
          positionStatusCombination: data.positionStatusCombination && data.positionStatusCombination.id,

        },
      }  
     applyFilter(value)
   }
    if (name === 'resources') {  
      let value: any = {
        filters: {
          allocatedTo: data.allocatedTo,
          experience: data.experience,
          job_role: data.job_role,
          position_status: data.position_status,
          positionStatusCombination: data.positionStatusCombination && data.positionStatusCombination.id,
          job_type: data.job_type,
          dateWithin: data.dateWithin,
          core_skills: data.core_skills,
          coreSkillsCombination: data.coreSkillsCombination && data.coreSkillsCombination.id,
          otherSkillsCombination: data.otherSkillsCombination && data.otherSkillsCombination.id,
          otherSkills: data.otherSkills,
          billingType: data.billingType,
          currencyType: data.currencyType,
          rates: data.minimumBudget !=='' && data.maximumBudget !== '' ? {
            from: data.minimumBudget,
            to: data.maximumBudget
          }: undefined,
          location: data.location,
          availability: data.availability && data.availability.value ,
          sourcedBy: data.sourcedBy,
          resource_status: data.resource_status,
         // candidateWorkType: data.candidateWorkType,
          behalf_of: data.behalf_of,
          preferred_work_type: data.preferred_work_type,
          country: data.country,
          nationality: data.nationality
        },
      }
      applyResourceFilter(value)      
    }
    if (name === 'inContract') {  
      let value: any = {
        filters: {
          allocatedTo: data.allocatedTo,
          experience: data.experience,
          job_role: data.job_role,
          position_status: data.position_status,
          positionStatusCombination: data.positionStatusCombination && data.positionStatusCombination.id,
          job_type: data.job_type,
          dateWithin: data.dateWithin,
          core_skills: data.core_skills,
          coreSkillsCombination: data.coreSkillsCombination && data.coreSkillsCombination.id,
          otherSkills: data.otherSkills,
          billingType: data.billingType,
          currencyType: data.currencyType,
          rates: data.minimumBudget !=='' && data.maximumBudget !== '' ? {
            from: data.minimumBudget,
            to: data.maximumBudget
          }: undefined,
          location: data.location,
          availability: data.availability && data.availability.value ,
          sourcedBy: data.sourcedBy,
          contractStatus: data.contractStatus,
          candidateWorkType: data.candidateWorkType,
          behalf_of: data.behalf_of,
          customerName: data.customerName
        },
      }
      applyResourceFilter(value)      
    }
    if(name === 'company'){            
      applyCompanyFilter(data)
    }
    if (name === 'companyTimesheet') {
      applyCompanysheetFilter(data)
    }
    if (name === 'candidateTimesheet') {
      applyCandidatesheetFilter(data)
    }
    if (name === 'CRpositions') {
      applyCrPositionFilter(data)
    }
    if (name === 'CRresources') {
      applyCrResourceFilter(data)
    }
  }
 
  const onClick = (type: string) => {  
    switch (type) {
      case 'positions':
        setFilter(true)
        setResourceFilter(false)
        setCompanyFilter(false)
        setCandidatesheetFilter(false)
        setIncontractFilter(false)
        return
      case 'resources':
        setFilter(false)
        setResourceFilter(true)
        setCompanyFilter(false)
        setCandidatesheetFilter(false)
        setIncontractFilter(false)
        return
      case 'inContract':
        setFilter(false)
        setResourceFilter(false)
        setCompanyFilter(false)
        setCandidatesheetFilter(false)
        setIncontractFilter(true)
        return
      case 'CRresources':
        setFilter(false)
        setResourceFilter(false)
        setCompanyFilter(false)
        setCandidatesheetFilter(false)
        setCompanysheetFilter(false)
        setCrPositionFilter(false)
        setCrResourceFilter(true)
        setIncontractFilter(false)
        return
      case 'CRPositions':
        setFilter(false)
        setResourceFilter(false)
        setCompanyFilter(false)
        setCandidatesheetFilter(false)
        setCompanysheetFilter(false)
        setCrResourceFilter(false)
        setCrPositionFilter(true)
        return
      case 'company':
        setFilter(false)
        setResourceFilter(false)
        setCompanyFilter(true)
        setCandidatesheetFilter(false)
        setIncontractFilter(false)
        return
      case 'companyTimesheet':
        setCompanysheetFilter(true)
        setFilter(false)
        setResourceFilter(false)
        setCompanyFilter(false)
        setCandidatesheetFilter(false)
        setIncontractFilter(false)
        return
      case 'candidateTimesheet':   
        setCandidatesheetFilter(true)
        setCompanysheetFilter(false)
        setFilter(false)
        setResourceFilter(false)
        setCompanyFilter(false)
        setIncontractFilter(false)
        return
      case 'companyTimesheetSettings':   
        setCandidatesheetFilter(true)
        setCompanysheetFilter(false)
        setFilter(false)
        setResourceFilter(false)
        setCompanyFilter(false)
        return
  }
}

const [search, setSearch] = useState(null)
const debouncedSearchTerm = useDebounce(search, 500);

const changeSearch = (e: any) => { 
  setSearch(e) 
}

const closeHandle=()=>{
 
  setshowNotificationTab(!showNotificationTab);
}

  useEffect(() => {
  
  if (debouncedSearchTerm !== null ) {
    searchChange && searchChange(debouncedSearchTerm)
}
}, [debouncedSearchTerm])

const  applyDurationFilter = (data: any) => {
  let value = {
    dateWithin : data !== undefined ? {from: data.from, to: data.to} : undefined
  }
  applyCandidatesheetFilter(value) 
  }
  
  const applyReportsFilter = (data: any) => {
    
    let filters = {
      "month": data.month && data.month.id,
      "year": data.year && data.year !== '' ?  parseInt(data.year) : undefined
    }
    timeSheetReportsFilter(filters)
  }

  
return (
    <div className={Styles.dashHead}>
      <div className={Styles.mobileHead}>
        <h3>
          {title !== false &&
            <Breadcrumbs data={item} onItemSelect={onselect} />
          }
          {jobId !== undefined && 
            <div className={Styles.userId}>{'( ID - '+jobId+' )'}</div>
          }
          {title == false &&
            <div className={Styles.roleHeadWrap}>
              <div className={Styles.rolehead}>{name} - <span>{role} @ {companyName}</span></div>
              <div className={checkTimesheetStatus(timesheetStatus).class}>
                {checkTimesheetStatus(timesheetStatus).value}
              </div>
            </div>
          }
        </h3>
        {navigateTo && (
          <Button onClick={headerNavigation} variant="primary" size="small">
            {navigateTo === "../applyPositions"
              ? "Apply for this Position"
              : "Add New"}
          </Button>
        )}
        {priority && <div className={classnames("headWithLabel", Styles.headWithLabel)}><label className={priorityClass(priority) }>{checkPriority(priority)}</label></div>} 
        {popupMenu && (
          <div className={Styles.popupmenu}>
          <PopupMenu>
            <div className={Styles.popupLinks}>
              { jobStatus !== 3 && 
              <Link to="" onClick={() => updatePosition('edit')}><Icon icon="lucide:edit-2"/>Edit</Link>}
              <Link to="" onClick={() =>  crowdsourcingChange(positionData && positionData.crowdsourcing_enabled === true ? 'Disable crowdsourcing' : 'Enable crowdsourcing')}><div className={Styles.tggleBtn}><Toggle onChange={() => {crowdsourcingChange(positionData && positionData.crowdsourcing_enabled === true ? 'Disable crowdsourcing' : 'Enable crowdsourcing')}} checked={positionData && positionData.crowdsourcing_enabled}/></div>{positionData && positionData.crowdsourcing_enabled === true ? 'Disable crowdsourcing' : 'Enable crowdsourcing'}</Link>
              <Link to="" onClick={() => updatePosition( jobStatus === 3 ? 'reopen' : 'close')}><Icon icon="ep:circle-close" />{jobStatus === 3 ? 'Reopen Position' : 'Close Position'}</Link>
              { (loginId === 'f1c0dffa-e416-43b7-ab50-e907254f9514' || loginId === allocatedToId) &&  <Link to="" className={Styles.danger} onClick={() => updatePosition('delete')} ><Icon icon="material-symbols:delete-outline-rounded" />Delete</Link>}
            </div>
          </PopupMenu>
          </div>
        )}
      </div>
      {searchChange && <SearchBar searchChange={changeSearch} onClick={onClick} type={type} filterNumber={filterNumber} filtervalues={filterValues} tagClose={(data: any) => { closeTag(data); setDefaultValues(data) }} />}
      <div className={Styles.notiWithSort}>
       { dashboard && <DashboardFilter applyDashboardFilter={applyDashboardFilter}/>}
      {type === 'candidateTimesheet' && <TimsheetDurationFilter applyDurationFilter={applyDurationFilter} />}
      { type ==='reports' && <ReportsDurationFilter applyDurationFilter={applyReportsFilter} /> }

        <div className={Styles.notification}>
          <Link to="/help">
            <Icon icon="charm:help" />
          </Link>
          <Link to="/settings">
            <Icon icon="tabler:settings" />
          </Link>
          <Link to="#" onClick={closeHandle}>
            <Icon icon="iconoir:bell" />
          </Link>
        </div>
      </div>
      {showNotificationTab &&   <NotificationTab setshowNotificationTab={setshowNotificationTab} showNotificationTab={showNotificationTab}/>}
      {filter && <PositionFilter onClose={() => setFilter(false)} ClickHandler={(data: any) => { clickHandler(data, 'positions'); setFilter(false) }} companyList={companyList} allocatedTo={allocatedTo} positionName={positionName} defaultValues={filterValues} jobRolesList={ jobRolesList} />}
      {resourceFilter && <ResourceFilter onClose={() => setResourceFilter(false)} ClickHandler={(data: any) => { clickHandler(data, 'resources'); setResourceFilter(false) }} defaultValues={filterValues} jobId={''} allocatedTo={allocatedTo} getProviderResources={getProviderResources} getRecruiterResources={getRecruiterResources} behalf_of={behalf_of} skillsList={skillsList} jobRolesList={jobRolesList} />}
      {inContractFilter && <InContractFilter onClose={() => setIncontractFilter(false)} ClickHandler={(data: any) => { clickHandler(data, 'inContract'); setIncontractFilter(false) }} companyList={companyList} defaultValues={filterValues} jobId={''} allocatedTo={allocatedTo} getProviderResources={getProviderResources} getRecruiterResources={getRecruiterResources} behalf_of={behalf_of} skillsList={skillsList} jobRolesList={jobRolesList} />}
      {companyFilter && <CompanyFilter onClose={() => setCompanyFilter(false)} ClickHandler={(data: any) => { clickHandler(data, 'company'); setCompanyFilter(false) }} defaultValues={filterValues} allocatedTo={allocatedTo} skillsList={skillsList} />}
      {companysheetFilter && <CompanyTimesheetFilter onClose={() => setCompanysheetFilter(false)} clickHandler={(data: any) => { clickHandler(data, 'companyTimesheet'); setCompanysheetFilter(false)}} companyNames={companyList}/>}
      {candidatesheetFilter && <CandidateTimesheetFilter onClose={() => setCandidatesheetFilter(false)} clickHandler={(data: any) => { clickHandler(data, 'candidateTimesheet');  setCandidatesheetFilter(false)}} positionName={positionName} companyNames={companyList} defaultValues={candidateFilterValue} type={type}/>}
      {crResourceFilter && <CRresourceFilter onClose={() => setCrResourceFilter(false)} ClickHandler={(data: any) => { clickHandler(data, 'CRresources'); setCrResourceFilter(false) }} skillsList={skillsList} />}
      {crPositionFilter && <CRPositionFilter onClose={() => setCrPositionFilter(false)} ClickHandler={(data: any) => { clickHandler(data, 'CRpositions'); setCrPositionFilter(false) }} companyList={companyList} allocatedTo={allocatedTo} positionName={positionName} defaultValues={filterValues} skillsList={skillsList} />}
    {/* <DataRange/> */}
    </div>
  );
};

export default DashboardHeader;

function useDebounce(value: any, delay: any) {
  // State and setters for debounced value
  const [debouncedValue, setDebouncedValue] = useState(value);  
  useEffect(
      () => {
          // Update debounced value after delay
          const handler = setTimeout(() => {
              setDebouncedValue(value);
          }, delay);
          // Cancel the timeout if value changes (also on delay change or unmount)
          // This is how we prevent debounced value from updating if value is changed ...
          // .. within the delay period. Timeout gets cleared and restarted.
          return () => {
              clearTimeout(handler);
          };
      },
      [value, delay] // Only re-call effect if value or delay changes
  );
  return debouncedValue;
}
